module.exports = __webpack_public_path__ + "img/juhema.a90db99d.jpg";